import { lazy } from "react";
import Loadable from "app/components/Loadable";

const WhatsAppMessagePricingPage = Loadable(
  lazy(() => import("./WhatsAppMessagePricingPage"))
);

const WhatsAppMessagePricingRoutes = [
  {
    path: "/admin/whatsapp-message-pricing",
    element: <WhatsAppMessagePricingPage />,
  },
];

export default WhatsAppMessagePricingRoutes;
